import { SVGProps } from "react"
const House = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 58 58.4"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M57.7 26.6 49 18.5V5.4H39v3.9L29 0 .3 26.6c-.4.4-.4 1 0 1.4s1 .4 1.4 0L5 24.9v33.3h48V25l3.3 3.1c.2.2.4.3.7.3s.5-.1.7-.3c.4-.4.4-1 0-1.4ZM41 7.4h6v9.4l-6-5.6V7.4Zm-18 49V35.3c0-.5.4-.9.9-.9H34c.5 0 .9.4.9.9v21.1h-12Zm28 0H37V35.3c0-1.6-1.3-2.9-2.9-2.9H24c-1.6 0-2.9 1.3-2.9 2.9v21.1H7V23.2L29 2.7 43.3 16l5.7 5.3 2 1.9v33.2Z" />
  </svg>
)
export default House
